import { render, staticRenderFns } from "./FormUser.vue?vue&type=template&id=fc74a456&scoped=true&"
import script from "./FormUser.vue?vue&type=script&lang=js&"
export * from "./FormUser.vue?vue&type=script&lang=js&"
import style0 from "./FormUser.vue?vue&type=style&index=0&id=fc74a456&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fc74a456",
  null
  
)

export default component.exports